var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1102(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334,
    height: 143.26,
    viewBox: "0 0 334 143.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(-521 -274.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M721.951,175.147v62.1a1.563,1.563,0,0,1-1.562,1.563H614.97a1.318,1.318,0,0,1-.224-.017,1.562,1.562,0,0,1-1.339-1.546v-62.1a1.563,1.563,0,0,1,1.562-1.563H720.387a1.563,1.563,0,0,1,1.563,1.562Z",
    transform: "translate(121.849 106.916)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 13.716,
    cy: 13.716,
    r: 13.716,
    transform: "translate(748.112 289.99)",
    fill: "#38bb93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M689.372,267.746H622.085a1.375,1.375,0,0,1-.251-.02L653.657,212.6a2.228,2.228,0,0,1,3.879,0l21.358,36.992,1.023,1.77Z",
    transform: "translate(115.469 78.229)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M714.35,236.363H691.377l11.278-16.381.812-1.18.406-.59,1.023,1.77Z",
    transform: "translate(90.49 109.611)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M872.777,318.4h-58.2l11.278-16.381.812-1.18,14.7-21.348a2.974,2.974,0,0,1,4.414-.264,2.665,2.665,0,0,1,.212.264Z",
    transform: "translate(-30.472 27.574)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M708.922,153.558a5.01,5.01,0,0,0-4.7-3.308H593.366a5,5,0,0,0-5,5v87.623a5.006,5.006,0,0,0,5,5H704.218a5.006,5.006,0,0,0,5-5V155.249A4.961,4.961,0,0,0,708.922,153.558Zm-.294,89.314a4.416,4.416,0,0,1-4.411,4.411H593.366a4.416,4.416,0,0,1-4.411-4.411V155.249a4.416,4.416,0,0,1,4.411-4.411H704.218a4.416,4.416,0,0,1,4.411,4.411Z",
    transform: "translate(140.808 124.584)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235-2",
    "data-name": "Path 1235",
    d: "M721.951,175.147v62.1a1.563,1.563,0,0,1-1.562,1.563H614.97a1.318,1.318,0,0,1-.224-.017,1.562,1.562,0,0,1-1.339-1.546v-62.1a1.563,1.563,0,0,1,1.562-1.563H720.387a1.563,1.563,0,0,1,1.563,1.562Z",
    transform: "translate(-80.751 106.987)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15-2",
    "data-name": "Ellipse 15",
    cx: 13.716,
    cy: 13.716,
    r: 13.716,
    transform: "translate(545.512 290.062)",
    fill: "#38bb93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236-2",
    "data-name": "Path 1236",
    d: "M689.372,267.746H622.085a1.375,1.375,0,0,1-.251-.02L653.657,212.6a2.228,2.228,0,0,1,3.879,0l21.358,36.992,1.023,1.77Z",
    transform: "translate(-87.131 78.301)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237-2",
    "data-name": "Path 1237",
    d: "M714.35,236.363H691.377l11.278-16.381.812-1.18.406-.59,1.023,1.77Z",
    transform: "translate(-112.109 109.683)",
    fill: "#6b6b6b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238-2",
    "data-name": "Path 1238",
    d: "M872.777,318.4h-58.2l11.278-16.381.812-1.18,14.7-21.348a2.974,2.974,0,0,1,4.414-.264,2.665,2.665,0,0,1,.212.264Z",
    transform: "translate(-233.071 27.646)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239-2",
    "data-name": "Path 1239",
    d: "M708.922,153.558a5.01,5.01,0,0,0-4.7-3.308H593.366a5,5,0,0,0-5,5v87.623a5.006,5.006,0,0,0,5,5H704.218a5.006,5.006,0,0,0,5-5V155.249A4.961,4.961,0,0,0,708.922,153.558Zm-.294,89.314a4.416,4.416,0,0,1-4.411,4.411H593.366a4.416,4.416,0,0,1-4.411-4.411V155.249a4.416,4.416,0,0,1,4.411-4.411H704.218a4.416,4.416,0,0,1,4.411,4.411Z",
    transform: "translate(-61.793 124.75)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1024_w_x_576_h_pixels",
    "data-name": "1024 (w) x 576 (h) pixels",
    transform: "translate(587 390.905)",
    fill: "#303030",
    fontSize: 12,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -65,
    y: 0
  }, "1024 (w) x 576 (h) pixels")), /*#__PURE__*/React.createElement("text", {
    id: "_1280_w_x_720_h_pixels",
    "data-name": "1280 (w) x 720 (h) pixels",
    transform: "translate(790 390.905)",
    fill: "#303030",
    fontSize: 12,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64,
    y: 0
  }, "1280 (w) x 720 (h) pixels")), /*#__PURE__*/React.createElement("text", {
    id: "_OR_",
    "data-name": "(OR)",
    transform: "translate(685 331)",
    fill: "#303030",
    fontSize: 17,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600,
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17,
    y: 0
  }, "(OR)")), /*#__PURE__*/React.createElement("path", {
    id: "corref",
    d: "M48,40a8,8,0,1,0,8,8A8,8,0,0,0,48,40Zm4.4,6.533-5.333,4a.667.667,0,0,1-.934-.133l-2-2.667a.667.667,0,0,1,1.067-.8l1.6,2.133,4.8-3.6a.667.667,0,0,1,.8,1.067Z",
    transform: "translate(529.027 372.527) rotate(-13)",
    fill: "#14c037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "corref-2",
    "data-name": "corref",
    d: "M48,40a8,8,0,1,0,8,8A8,8,0,0,0,48,40Zm4.4,6.533-5.333,4a.667.667,0,0,1-.934-.133l-2-2.667a.667.667,0,0,1,1.067-.8l1.6,2.133,4.8-3.6a.667.667,0,0,1,.8,1.067Z",
    transform: "translate(732.027 372.527) rotate(-13)",
    fill: "#14c037"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1102);
export default __webpack_public_path__ + "static/media/Group_1102.07f8d18d39283fbf5c20ae2f5ceddab0.svg";
export { ForwardRef as ReactComponent };